
import '@/bootstrap'
import { mountApp } from '@/util/mountApp'
import { App } from '@/routes/user_registration'

mountApp(<App />)
